// extracted by mini-css-extract-plugin
export default {"container":"top-menu_container__Jkzsk","title":"top-menu_title__P5h-I"};